import { render, staticRenderFns } from "./goodAtPanel.vue?vue&type=template&id=50f7582e&scoped=true&"
import script from "./goodAtPanel.vue?vue&type=script&lang=js&"
export * from "./goodAtPanel.vue?vue&type=script&lang=js&"
import style0 from "./goodAtPanel.vue?vue&type=style&index=0&id=50f7582e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7582e",
  null
  
)

export default component.exports